// W1-4 — THE UPGRADE BUTTON, GLOWING, TOP RIGHT. Owner order, 2026-07-29.
//
// It lives in its own file rather than inline in the nav for the reason every R7/R8 extraction has had:
// it takes props, holds no state and calls no hook, so `scripts/w1-upgrade-button.mjs` can CALL it and
// read the tree back. Inline in App.tsx the only instrument available was a regex over 16,000 lines,
// and the whole point of this button is a CONDITION — not that it renders, but exactly WHO it renders
// for. A regex cannot answer that. Calling it four times, once per tier, can.
//
// WHAT IT IS FOR. W1-2 and W1-3 both shipped copy that ends "Tap Upgrade at the top right": every
// locked door on the site, Lala's hard stop, and her by-construction floor. That sentence is a promise
// about this control. Before this, the only Upgrade was inside the account dropdown (T8-8), which is
// not top right and is not something a refused member can find from a sentence.
//
// THE CONDITION IS THE WHOLE THING, AND IT HAS THREE PARTS:
//   • signed in — a refusal cannot reach a visitor, because the gate 401s her first. Her honest first
//     step is Log in, and that is what the nav already offers her.
//   • BELOW VET — her spec is one sentence: A VET SEES NONE. There is nothing above a Vet to sell.
//   • AND THE TIER MUST BE KNOWN. This is the part that would be missed. `serverTier` is null until
//     /api/membership/status answers, and null !== "vet", so the obvious test renders a glowing sales
//     button to a Vet on every single page load until that fetch lands. An unanswered tier shows
//     nothing. It is the W1-1 third-state law pointed the other way: there, "not answered yet" must
//     never harden into a refusal; here it must never soften into a pitch.
//
// Every tier below Vet gets the SAME label, "Upgrade", including free: the refusal copy names this
// button by that word, so it has to be true for everyone who can be refused.
import { Crown } from "lucide-react";

export function NavUpgrade({ isLoggedIn, tier, onUpgrade }: {
  isLoggedIn: boolean;
  /** Her tier as the SERVER said it. `null` means the server has not answered yet, which is not "free". */
  tier: string | null;
  onUpgrade: () => void;
}) {
  if (!isLoggedIn || !tier || tier === "vet") return null;
  return (
    <button
      type="button"
      className="nav-upgrade"
      onClick={onUpgrade}
      aria-label="Upgrade your membership"
    >
      <Crown size={15} /> Upgrade
    </button>
  );
}
